/** InsCoder WANG.J 2026-08-18 B + Multiple Buy X, Get Y cart progress refresh behavior **/
(function () {
  'use strict';

  var rootSelector = '[data-cust-multiple-buy-x-get-y-progress]';
  var giftSource = 'multiple-buy-x-get-y';
  var boundKey = '__custMultipleBuyXGetYProgressRefreshBound';
  var refreshPromise = null;
  var productPromises = {};
  var bannerTimers = new WeakMap();

  function splitList(value) { return String(value || '').split(',').map(function (item) { return item.trim(); }).filter(Boolean); }
  function isGift(item) {
    var props = item && item.properties ? item.properties : {};
    var source = props._source;
    return Boolean(props.free_gift || String(item && item.product_type || '').toLowerCase() === 'gwp' || source === 'cart-claim' || source === 'cart-gift' || source === 'new-customer-group-a' || source === 'new-customer-group-b' || source === giftSource);
  }
  function readConfig(root) {
    var minimumQuantity = Math.max(2, Math.floor(Number(root.dataset.minimumQuantity) || 2));
    if (!root.dataset.productId || !Number.isInteger(minimumQuantity) || minimumQuantity < 2) return null;
    return {
      id: root.dataset.productId, handle: root.dataset.productHandle || '', title: root.dataset.productTitle || '', minimumQuantity: minimumQuantity,
      giftHandle: root.dataset.productYHandle || '', giftVariantId: root.dataset.productYVariantId || '',
      productYAvailable: root.dataset.productYAvailable === 'true', excludedVariants: new Set(splitList(root.dataset.excludedVariantIds)),
      excludedPlans: splitList(root.dataset.excludedSellingPlanNames), progress: root.dataset.progressMessage || 'shade to unlock your free brush.',
      complete: root.dataset.progressMessageQualified || 'Your Double Sculpt Set is Complete.', moneyFormat: root.dataset.moneyFormat || '${{amount}}'
    };
  }
  function qualifiedQuantity(items, config) {
    return items.reduce(function (total, item) {
      var planName = item && item.selling_plan && item.selling_plan.name;
      var excludedPlan = planName && config.excludedPlans.some(function (name) { return planName.indexOf(name) !== -1; });
      if (String(item && item.product_id) !== String(config.id) || isGift(item) || config.excludedVariants.has(String(item && item.variant_id)) || excludedPlan) return total;
      return total + Math.max(0, Number(item.quantity) || 0);
    }, 0);
  }
  function progressMessage(config, remaining) {
    if (remaining <= 0) return config.complete;
    var progress = config.progress.replace(/\bshades?\b/, remaining === 1 ? 'shade' : 'shades');
    return [(remaining === 1 ? 'Add one more' : 'Add ' + remaining + ' more'), config.title, progress].filter(Boolean).join(' ');
  }
  function money(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, format);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }
  function product(config) {
    if (!config.handle) return Promise.reject(new Error('Product X handle is missing.'));
    if (!productPromises[config.handle]) {
      var rootUrl = window.routes && window.routes.root_url ? window.routes.root_url.replace(/\/$/, '') : '';
      productPromises[config.handle] = fetch(rootUrl + '/products/' + config.handle + '.js', { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Unable to load Product X.');
        return response.json();
      });
    }
    return productPromises[config.handle];
  }
  function promotionContainer(root) {
    return root && root.closest('[data-cart-buy-gety-el]');
  }
  function updatePrice(root, config) {
    /** InsCoder WANG.J 2026-09-08 B + Display gift Y value without changing product X picker pricing **/
    if (!config.giftHandle) return;
    product({ handle: config.giftHandle }).then(function (data) {
      var variant = (data.variants || []).find(function (item) { return String(item.id) === String(config.giftVariantId); });
      if (!variant) return; // Keep the server-rendered gift value if the variant is unavailable.
      var container = promotionContainer(root) || root;
      container.querySelectorAll('[data-buyx-gety-price]').forEach(function (element) { element.textContent = money(variant.price, config.moneyFormat); });
    }).catch(function (error) { console.warn('Unable to load Multiple Buy X gift value:', error); });
    /** InsCoder WANG.J 2026-09-08 E + Display gift Y value without changing product X picker pricing **/
  }
  function updateBanner(root, isComplete, remaining) {
    var container = promotionContainer(root) || root;
    var before = container.querySelector('[data-buyx-gety-before]');
    var after = container.querySelector('[data-buyx-gety-after]');
    var description = container.querySelector('[data-buyx-gety-before-description]');
    if (description && description.dataset.buyxGetyDescriptionTemplate) {
      description.textContent = description.dataset.buyxGetyDescriptionTemplate
        .replace(/\[\d+\]/, String(Math.max(0, remaining)))
        .replace(/\bshades?\b/g, remaining === 1 ? 'shade' : 'shades');
    }
    container.querySelectorAll('[data-buyx-gety-count]').forEach(function (element) { element.textContent = String(Math.max(0, remaining)); });
    if (!before || !after) return;
    window.clearTimeout(bannerTimers.get(root));
    before.classList.toggle('hidden', isComplete);
    after.classList.toggle('hidden', !isComplete);
    // if (isComplete) bannerTimers.set(root, window.setTimeout(function () { after.classList.add('hidden'); }, 3000));
  }
  function updateRoot(root, cart) {
    var config = readConfig(root);
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var itemCount = Number(cart && cart.item_count) || 0;
    var wrapper = promotionContainer(root);
    if (wrapper) wrapper.classList.toggle('is-hidden', itemCount <= 0);
    if (!config || !config.productYAvailable || itemCount <= 0) { root.classList.add('is-hidden'); return; }
    var quantity = qualifiedQuantity(items, config);
    var remaining = config.minimumQuantity - quantity;
    var complete = remaining <= 0;
    var message = root.querySelector('[data-cust-multiple-buy-x-get-y-progress-message]');
    var track = root.querySelector('[data-cust-multiple-buy-x-get-y-progress-track]');
    var fill = root.querySelector('[data-cust-multiple-buy-x-get-y-progress-fill]');
    root.classList.remove('is-hidden'); root.toggleAttribute('data-complete', complete);
    if (message) message.textContent = progressMessage(config, remaining);
    if (track) { track.setAttribute('aria-valuenow', String(Math.min(quantity, config.minimumQuantity))); track.setAttribute('aria-label', config.title + ' progress'); }
    if (fill) fill.style.width = Math.min(quantity / config.minimumQuantity * 100, 100) + '%';
    updateBanner(root, complete, remaining);
    updatePrice(root, config);
  }
  function getVariantPicker(root) {
    var wrapper = root && root.closest('[data-cart-buy-gety-el]');
    return wrapper && wrapper.querySelector('[data-buyx-gety-variant-picker]');
  }
  function syncPickerVariant(root) {
    var config = readConfig(root);
    var picker = getVariantPicker(root);
    var addButton = picker && picker.querySelector('[data-buyx-gety-variant-picker-add]');
    var selectedOptions;
    if (!config || !picker || !addButton) return Promise.resolve();
    selectedOptions = Array.from(picker.querySelectorAll('input[type="radio"]:checked')).map(function (input) { return input.value; });
    return product(config).then(function (data) {
      var selectedVariant = (data.variants || []).find(function (variant) {
        return variant.available && variant.options.length === selectedOptions.length && variant.options.every(function (option, index) { return option === selectedOptions[index]; });
      });
      if (!selectedVariant) return;
      addButton.dataset.variantId = selectedVariant.id;
      picker.querySelectorAll('[data-buyx-gety-variant-picker-price]').forEach(function (price) { price.textContent = money(selectedVariant.price, config.moneyFormat); });
    }).catch(function (error) { console.error('Unable to update Product X variant:', error); });
  }
  function openVariantPicker(root) {
    var picker = getVariantPicker(root);
    if (!picker) return;
    picker.classList.add('variant-picker__expanded');
    picker.setAttribute('aria-hidden', 'false');
    syncPickerVariant(root);
  }
  function closeVariantPicker(button) {
    var picker = button.closest('[data-buyx-gety-variant-picker]');
    if (!picker) return;
    picker.classList.remove('variant-picker__expanded');
    picker.setAttribute('aria-hidden', 'true');
  }
  function addPickerVariant(button) {
    var picker = button.closest('[data-buyx-gety-variant-picker]');
    var wrapper = picker && picker.closest('[data-cart-buy-gety-el]');
    var root = wrapper && wrapper.querySelector(rootSelector);
    var variantId = button.dataset.variantId;
    if (!root || !variantId || button.disabled) return;
    button.disabled = true;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
      .then(function (response) { if (!response.ok) throw new Error('Unable to add Product X.'); return response.json(); })
      .then(function () {
        closeVariantPicker(button);
        return typeof window.getCart === 'function' ? window.getCart() : null;
      })
      .then(function (cart) {
        if (cart) updateRoot(root, cart);
        var notification = document.querySelector('cart-notification');
        if (notification && typeof notification.renderContents === 'function') {
          return notification.renderContents('FROM_ADD_TO_CART');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return cart;
      })
      .catch(function (error) { console.error('Unable to add Multiple Buy X product:', error); button.disabled = false; });
  }
  function refresh() {
    if (refreshPromise || typeof window.getCart !== 'function') return refreshPromise;
    refreshPromise = window.getCart().then(function (cart) { document.querySelectorAll(rootSelector).forEach(function (root) { updateRoot(root, cart); }); }).catch(function (error) { console.error('Unable to refresh Multiple Buy X, Get Y progress:', error); }).finally(function () { refreshPromise = null; });
    return refreshPromise;
  }
  function initialize() {
    if (!document.querySelector(rootSelector)) return;
    if (!window[boundKey]) {
      document.addEventListener('addToCartSuccess', refresh); document.addEventListener('cart:refresh', refresh);
      document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-buyx-gety-atc-button]');
        var container;
        if (!button) return;
        event.preventDefault();
        container = button.closest('[data-cart-buy-gety-el]');
        openVariantPicker(container && container.querySelector(rootSelector));
      });
      document.addEventListener('click', function (event) {
        var closeButton = event.target.closest('[data-buyx-gety-variant-picker-close]');
        var addButton = event.target.closest('[data-buyx-gety-variant-picker-add]');
        if (closeButton) { event.preventDefault(); closeVariantPicker(closeButton); }
        if (addButton) { event.preventDefault(); event.stopPropagation(); addPickerVariant(addButton); }
      });
      document.addEventListener('change', function (event) {
        var picker = event.target.closest('[data-buyx-gety-variant-picker]');
        var wrapper = picker && picker.closest('[data-cart-buy-gety-el]');
        if (picker && wrapper) syncPickerVariant(wrapper.querySelector(rootSelector));
      });
      window[boundKey] = true;
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
})();
/** InsCoder WANG.J 2026-08-18 E + Multiple Buy X, Get Y cart progress refresh behavior **/
